// Helper type for CSS class strings or arrays of strings
type SlotClassDefinition = string | string[]

// Define all known configurable slots for the Carousel component.
//	Look at the Carousel component for more details.
//	node_modules\@nuxt\ui\dist\runtime\components\Carousel.vue (all props.ui.<prop> are available)
//	NOTE: props.ui.dot is available put not explicitly defined in the component's props
//	but can be seen used in the bottom of the template.
interface CarouselSlots {
	root?: SlotClassDefinition
	viewport?: SlotClassDefinition
	container?: SlotClassDefinition
	item?: SlotClassDefinition
	controls?: SlotClassDefinition
	arrows?: SlotClassDefinition
	prev?: SlotClassDefinition
	next?: SlotClassDefinition
	dots?: SlotClassDefinition
	dot?: SlotClassDefinition
}

// Define the structure for Carousel variants and their possible states
interface CarouselVariants {
	orientation?: {
		vertical?: Partial<CarouselSlots>
		horizontal?: Partial<CarouselSlots>
	}
	active?: {
		true?: Partial<CarouselSlots>
		false?: Partial<CarouselSlots>
	}
	dot?: SlotClassDefinition
}

// Comprehensive type for our Carousel theme configuration (could be extended e.g. for default variants)
export interface ExtendedCarouselThemeConfig {
	slots?: Partial<CarouselSlots>
	variants?: Partial<CarouselVariants>
	// defaultVariants?: {
	//   orientation?: 'horizontal' | 'vertical';
	//   active?: 'true' | 'false';
	// };
}

export default {
	slots: {
		root: 'relative focus:outline-none',
		viewport: 'overflow-hidden',
		container: 'flex items-start',
		item: 'min-w-0 shrink-0 basis-full',
		controls: '',
		arrows: '',
		prev: 'absolute rounded-full',
		next: 'absolute rounded-full',
		dots: 'absolute inset-x-0 -bottom-7 flex flex-wrap items-center justify-center gap-3',
		dot: [
			'cursor-pointer size-3 bg-accented rounded-full',
			'transition'
		]
	},
	variants: {
		orientation: {
			vertical: {
				container: 'flex-col -mt-4',
				item: 'pt-4',
				prev: 'top-4 sm:-top-12 left-1/2 -translate-x-1/2 rotate-90 rtl:-rotate-90',
				next: 'bottom-4 sm:-bottom-12 left-1/2 -translate-x-1/2 rotate-90 rtl:-rotate-90'
			},
			horizontal: {
				container: 'flex-row -ms-4',
				item: 'ps-8 sm:ps-6 2xl:px-4',
				prev: 'start-4 sm:-start-12 top-1/2 -translate-y-1/2',
				next: 'end-4 sm:-end-12 top-1/2 -translate-y-1/2'
			}
		},
		dot: [
			'cursor-pointer size-3 rounded-full',
			'transition'
		],
		active: {
			true: {
				dot: 'bg-primary'
			},
			false: {
				dot: 'bg-gray-200'
			}
		}
	}
} satisfies ExtendedCarouselThemeConfig
